import { render, staticRenderFns } from "./TariffFunctionChangeConfirm.vue?vue&type=template&id=23170552"
import script from "./TariffFunctionChangeConfirm.vue?vue&type=script&lang=js"
export * from "./TariffFunctionChangeConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports